import { useRef } from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { TooltipContainer } from "@outplayed/tooltips";
import DefaultSelect from "../DefaultSelect";
import { FILTER_IS_NOT_DEFAULT_CLASSNAME } from "../FilterManager";
import { FilterSelect, FilterOption } from "@ugg/shared/interfaces/filter-manager.interface";

// ARAM Mayhem augment rarity. Same shape as Rank / Region / QueueType: a
// DefaultSelect bound to a query param through onFilterChange, so it is
// shareable, survives reload, and highlights when off its default.
interface AugmentRarityProps extends FilterSelect {
  className?: string;
  options: FilterOption[];
  isMobile?: boolean;
  disableTooltip?: boolean;
}

export default function AugmentRarity(props: AugmentRarityProps) {
  const tooltipRef = useRef<{ forceClose: Function }>({ forceClose: () => {} });
  const { t } = useTranslation();
  const { className, isMobile, options, filters, isDefault, onFilterChange, disableTooltip } = props;

  return (
    <TooltipContainer
      ref={tooltipRef}
      tooltipInfo={t("Change Rarity")}
      customClassName={className}
      disableTooltip={isMobile || disableTooltip}
    >
      <div>
        <DefaultSelect
          title={t("Change Rarity")}
          group="rarity"
          isMobile={isMobile}
          className={classnames("filter-select filter-select_rarity", {
            [FILTER_IS_NOT_DEFAULT_CLASSNAME]: typeof isDefault === "boolean" ? !isDefault : !isDefault?.("rarity"),
          })}
          options={options}
          onChange={(selected: (typeof options)[number]) => {
            onFilterChange("rarity", selected);
          }}
          value={filters.rarity}
          width={170}
          isSearchable={false}
          onMenuClose={() => tooltipRef.current.forceClose()}
        />
      </div>
    </TooltipContainer>
  );
}
